import { HTTP } from '../../http';

const state = {
  reportCreated: false
};

const mutations = {
  SET_REPORT_CREATED(state, data) {
    state.reportCreated = data;
  }
};

const getters = {

};

const actions = {
  createReport: ({ commit }, payload) => {
    commit('SET_REPORT_CREATED', false);
    return HTTP.post('/api/create-report', payload)
      .then(response => {
        commit('SET_REPORT_CREATED', response.data.report_status);
        return response;
      })
      .catch(error => {
        throw error.response;
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
